import { createContext } from 'react';
import { ITabsVariants, tabsVariants } from './tabs.variants';

export type TabsContextProps = {
  variant?: keyof typeof tabsVariants | (string & {});
  variants?: ITabsVariants;
};

export const TabsContext = createContext<TabsContextProps>({});

export const TabsProvider = TabsContext.Provider;
